export const USER_ACTIVITY_LIST = [
  'TOUCH',
  'BANKING',
  'BUYGOOD',
  'SUBCRIBE',
  'WEBSITE',
  'CHECKIN',
  'READEMAIL',
  'EMAILOUT',
  'EMAILIN',
  'CALLOUT',
  'CALLIN',
  'LOGIN',
  'LOGINAPP',
  'LOGINWEB',
  'CONTACTFORM',
  'SHOPPINGCART',
  'REDEEM',
];

